import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: 50%;\n  display: block;\n  height: 8px;\n  margin: 0 4px;\n  opacity: ", ";\n  transition: opacity ", ";\n  width: 8px;\n\n  &:hover,\n  &:focus {\n    opacity: 0.5;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { VisuallyHiddenElement } from '@scp/ui-shared/theme/resets';
import { withoutProps } from '@scp/ui-shared/core/hoc';
import { LinkOrButton } from '@scp/ui-shared/components/buttons';
import { withRippleEffect } from '@scp/ui-shared/theme/ripple-effect';
import { color, property } from '@scp/ui-shared/theme/variables';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
var E2E_LABEL = 'carousel';
var TEXT = {
  LABEL: 'Click to open slide '
};
var Item = styled(withRippleEffect(withoutProps(LinkOrButton, ['active']))).attrs({
  role: 'tab'
})(_templateObject(), color.palette.grey180, function (props) {
  return props.active ? 1 : 0.19;
}, property.transition);
export var CarouselDot = function CarouselDot(_ref) {
  var id = _ref.id,
      dotIndex = _ref.dotIndex,
      activeIndex = _ref.activeIndex,
      onPageChange = _ref.onPageChange;
  var active = activeIndex === dotIndex;
  var label = TEXT.LABEL + (dotIndex + 1);

  function handleClick(event) {
    event.preventDefault();

    if (onPageChange) {
      onPageChange(dotIndex);
    }
  }

  function handleKeyDown(_ref2) {
    var key = _ref2.key;

    if (!onPageChange) {
      return;
    } // Accessibility: allow to change tabs with keyboard arrows


    if (key === 'ArrowRight' || key === 'ArrowDown') {
      onPageChange(activeIndex + 1);
    }

    if (key === 'ArrowLeft' || key === 'ArrowUp') {
      onPageChange(activeIndex - 1);
    }
  }

  return React.createElement(Item, {
    id: id,
    active: active,
    href: "#".concat(id, "-tab"),
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    "aria-selected": active,
    "aria-controls": "".concat(id, "-tab"),
    tabIndex: active ? -1 : 0,
    title: label,
    "data-e2e": getE2eLabel(E2E_LABEL, "-dot-".concat(dotIndex))
  }, React.createElement(VisuallyHiddenElement, null, label));
};